<script setup>
import { useSupplierImportStore } from '@supplier/stores/useSupplierImportStore'
import { useI18n } from 'vue-i18n'

import AppBadge from '@ui/app-badge/AppBadge.vue'
import AppTooltip from '@ui/app-tooltip/AppTooltip.vue'

const { t } = useI18n()
const importStore = useSupplierImportStore()
</script>

<template>
  <app-tooltip
    v-if="importStore.status"
    position="bottom"
    :text="t('ui.supplier_portal.header.products_imported')"
  >
    <template #trigger="{ bind }">
      <app-badge
        v-bind="bind"
        type="label"
        variant="purple-fade"
        left-icon="Spinner"
        :text="String(importStore.imported)"
      />
    </template>
  </app-tooltip>
</template>
